export default "/fonts/vendor/katex/dist/KaTeX_Main-Bold.woff?0c3b8929d377c0e9b2f3a9c872e3337b";